import { getTwoDecimalFormatter } from '../../../utils/numberUtils';

const formatter = getTwoDecimalFormatter();

/**
 * Calculate number of units (e.g., tablets, ml) based on weight, strength, and dose
 * Formula: (patientWeight * dose) / strength
 */
export const calculateNumberOfUnitsResult = (
  patientWeight: number,
  strength: number,
  dose: number
): string => {
  if (strength === 0) return '0.00';
  return formatter.format((patientWeight * dose) / strength);
};

/**
 * Calculate drug amount (mg/kg) based on weight, strength, and number of units
 * Formula: (numberOfUnits / patientWeight) * strength
 */
export const calculateAmountResult = (
  patientWeight: number,
  strength: number,
  numberOfUnits: number
): string => {
  if (patientWeight === 0) return '0.00';
  return formatter.format((numberOfUnits / patientWeight) * strength);
};

/**
 * Calculate required strength based on weight, number of units, and dose
 * Formula: (patientWeight * dose) / numberOfUnits
 */
export const calculateStrengthResult = (
  patientWeight: number,
  numberOfUnits: number,
  dose: number
): string => {
  if (numberOfUnits === 0) return '0.00';
  return formatter.format((patientWeight * dose) / numberOfUnits);
};

/**
 * Validator for numeric input - returns true if invalid
 */
export const notNullIsNumberValidator = (value: string): boolean =>
  value === '' || isNaN(Number(value));

/**
 * Convert kg to lbs
 */
const ONE_KG_IN_LBS = 2.20462;

export const convertKgToLbs = (kg: string): string => {
  if (kg === '') return '';
  return Number.isNaN(+kg)
    ? '0.00'
    : (Number.parseFloat(kg) * ONE_KG_IN_LBS).toFixed(2);
};

/**
 * Convert lbs to kg
 */
export const convertLbsToKg = (lbs: string): string => {
  if (lbs === '') return '';
  return Number.isNaN(+lbs)
    ? '0.00'
    : (Number.parseFloat(lbs) / ONE_KG_IN_LBS).toFixed(2);
};
